<template>
  <main class='timeline' v-if='!kql.loading'>
    <section v-if='children.length'>
      <header>
        <h2 v-html='kql.page.title' />
      </header>
      <Timeline :timelineitems='children' />
    </section>
    <section class='static layout' v-if='kql.page?.content?.layout'>
      <LayoutComponent :context='kql.page' :layout='JSON.parse(kql.page?.content?.layout)' />
    </section>
    <MainFooter/>
  </main>
</template>

<script setup>
  import { useStore } from '@/KQL.js'
  import { pageFromPath, filterPublicPages } from '@/utils'
  const kql = useStore();
  const children = computed(()=>filterPublicPages(pageFromPath(kql.page.uid, kql?.pages)?.children));
</script>

<style scoped>
section.static.layout {
    padding-top: var(--top-padding);
    width: var(--main-width-narrow);
    margin: auto;
}

header {
  width: var(--main-width-narrow);
  display: flex;
  justify-content: center;
  margin: auto;
  padding-top: var(--top-padding-moderate);
}

</style>
